import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import validate from '../../utils/validate';

import * as spActions from '../../actions/sp';
import AppNames from "../AppNames/AppNames";
import '../index.scss';
import { checkSession } from "../../api/api";
import * as messageConstants from '../../shared/messages';
import Message from "../Message";
import {
  MESSAGE_EVENT_TYPE
} from "../../constants/postMessages";
import { OIDC_ENTRA_ID_EAM_APPLICATION } from "../../constants/applicationTypes.js";
import RedirectUri from "./RedirectUri/RedirectUri";
import ClientCredentials from "./ClientCredentials/ClientCredentials";
import * as idpActions from "../../actions/idp";
import OidcIdpMetadataPopup from "../OidcApp/IdpOidcMetadataPopup/OidcIdpMetadataPopup";
import EntraIdTenantId from "./EntraIdTenantId/EntraIdTenantId";
import { DEFAULT_OIDC_ENTRA_ID_EAM_REDIRECT_URI } from "../../constants/oidcConstants";

export class OidcEntraIdEamApp extends Component {
  static propTypes = {
    history: PropTypes.object,
    match: PropTypes.shape({
      params: PropTypes.shape({
        applicationId: PropTypes.string,
      }),
    }),
    applicationId: PropTypes.string,
    applicationName: PropTypes.string,
    userFriendlyName: PropTypes.string,
    oidcProfile: PropTypes.object,
    oidcRedirectUris: PropTypes.array,
    clientId: PropTypes.string,
    entraIdTenantId: PropTypes.string,
    idpMetadata: PropTypes.object,
    showModalOidcIdpMetadata: PropTypes.bool,
    errorMsg: PropTypes.string,
    updateAppName: PropTypes.func,
    updateUserFriendlyName: PropTypes.func,
    updateEntraIdTenantId: PropTypes.func,
    addApp: PropTypes.func,
    updateApp: PropTypes.func,
    cancelAddApp: PropTypes.func,
    getAppById: PropTypes.func,
    updateOidcEntraIdEamRedirectUri: PropTypes.func,
    clearMessages: PropTypes.func,
    setErrorMessage: PropTypes.func,
    getIdpMetadata: PropTypes.func,
    showOidcIdpMetadataPopup: PropTypes.func,
    hideOidcIdpMetadataPopup: PropTypes.func,
    generateOidcClientCredentials: PropTypes.func,
    redirectToWorkflowPolicyPage: PropTypes.func,
  }

  handleFrameTasks = (e) => {
  };
  handleSaveSP = () => {
    let oidcProfile = this.props.oidcProfile;
    let entraIdTenantId = this.props.entraIdTenantId.trim();

    oidcProfile.oidcRedirectUris = this.props.oidcRedirectUris.filter(
        e => e.redirectUri.length > 0);
    oidcProfile.entraIdTenantId = entraIdTenantId;

    const newMeta = {
      name: this.props.applicationName,
      userFriendlyName: this.props.userFriendlyName,
      applicationType: OIDC_ENTRA_ID_EAM_APPLICATION,
      oidcProfile: oidcProfile,
      applicationId: this.props.applicationId
    }

    const constraints = {
      name: {
        presence: {
          allowEmpty: false,
          message: messageConstants.SBA_WARNING_BLANK_APPNAME
        }
      },
      userFriendlyName: {
        presence: {
          allowEmpty: false,
          message: messageConstants.SBA_WARNING_BLANK_USER_FRIENDLY_APPNAME
        }
      },
      oidcProfile: {
        presence: {
          allowEmpty: false,
          message: messageConstants.SBA_WARNING_BLANK_METADATA
        }
      },
    };

    const errors = validate(newMeta, constraints, {fullMessages: false});

    if (errors) {
      this.setState({errors});
      this.props.setErrorMessage(errors[Object.keys(errors)[0]]);
    } else {
      if (entraIdTenantId.length === 0) {
        this.props.setErrorMessage(messageConstants.OIDC_WARNING_BLANK_ENTRA_ID_TENANT_ID);
      } else {
        if (this.props.applicationId) {
          this.props.updateApp(newMeta);
        } else {
          this.props.addApp(newMeta);
        }
      }
    }
  };

  handleAddOidcCancel = () => {
    this.props.cancelAddApp();
  };
  handleEditApplication = () => {
    if (this.props.match.params.applicationId) {
      this.props.getAppById(this.props.match.params.applicationId);
    }
  };
  handleChangeAppName = (e) => {
    this.props.updateAppName(e.target.value);
  };
  handleChangeUserFriendlyName = (e) => {
    this.props.updateUserFriendlyName(e.target.value)
  };
  handleUserFriendlyNameBlur = () => {
    if (this.props.userFriendlyName.length === 0) {
      this.props.updateUserFriendlyName(this.props.applicationName)
    }
  };
  handleChangeEntraIdTenantId = (e) => {
    this.props.updateEntraIdTenantId(e.target.value);
  };
  handleGetIdpMetadata = () => {
    this.props.getIdpMetadata();
  };
  handleShowModalOidcIdpMetadata = () => {
    this.props.showOidcIdpMetadataPopup();
  };
  handleHideModalOidcIdpMetadata = () => {
    this.props.hideOidcIdpMetadataPopup()
  };
  generateOidcClientCredentials = () => {
    if (!this.props.match.params.applicationId) {
      this.props.generateOidcClientCredentials()
    }
  };

  componentDidMount() {
    if (checkSession(this.props.history)) {
      window.addEventListener(MESSAGE_EVENT_TYPE, this.handleFrameTasks);
      this.handleGetIdpMetadata();
      this.handleEditApplication();
      this.generateOidcClientCredentials();
      if (!this.props.match.params.applicationId) {
        this.props.updateOidcEntraIdEamRedirectUri(DEFAULT_OIDC_ENTRA_ID_EAM_REDIRECT_URI);
      }
    }
  };
  componentWillUnmount() {
    window.removeEventListener(MESSAGE_EVENT_TYPE, this.handleFrameTasks);
  };

  render() {
    const {applicationId, applicationName, userFriendlyName, oidcRedirectUris, clientId, entraIdTenantId, idpMetadata,
      errorMsg, clearMessages, updateOidcEntraIdEamRedirectUri, showModalOidcIdpMetadata} = this.props;
    return (
      <div className="AddApp-container">
        <div className="container">
          <Message errorMessage={errorMsg} clearMessages={clearMessages}/>
          <div className="row">
            <div className="col-xs-12 col-sm-12 col-md-12">
              <div className="add-edit-title">{applicationId
                  ? messageConstants.OIDC_ENTRA_ID_EAM_TITLE_EDIT
                  : messageConstants.OIDC_ENTRA_ID_EAM_TITLE_ADD}
              </div>
              <div className="add-edit-subtitle">
                {messageConstants.REDIRECT_TO_WORKFLOW_POLICY_PAGE_LABEL}
                <button id="redirectToWorkflowPolicyPageButton"
                        className="btn btn-link add-edit-subtitle-button"
                        onClick={this.props.redirectToWorkflowPolicyPage}>
                  {messageConstants.WORKFLOW_POLICY_PAGE}
                </button>
              </div>

              <AppNames applicationName={applicationName}
                        userFriendlyName={userFriendlyName}
                        handleChangeAppName={this.handleChangeAppName}
                        handleChangeUserFriendlyName={this.handleChangeUserFriendlyName}
                        handleUserFriendlyNameBlur={this.handleUserFriendlyNameBlur}/>

              <EntraIdTenantId entraIdTenantId={entraIdTenantId}
                               handleChangeEntraIdTenantId={this.handleChangeEntraIdTenantId}/>

              <RedirectUri oidcRedirectUris={oidcRedirectUris}
                           handleUpdateOidcRedirectUri={updateOidcEntraIdEamRedirectUri}/>

              &nbsp;
              <ClientCredentials clientId={clientId}/>

              <h3 className="sba-subtitle">{messageConstants.SBA_METADATA_REQUIRED_SP}</h3>

              <div className="add-edit-subtitle">
                {messageConstants.SBA_OIDC_METADATA_REQUIRED_SP_DESCRIPTION}
              </div>
              <div className="view-idp-metadata-block">
                <button id="showModalOidcIdpMetadataButton"
                        className="btn btn-link view-idp-metadata-button"
                        onClick={this.handleShowModalOidcIdpMetadata}>{messageConstants.OIDC_IDP_VIEW_AND_COPY_METADATA}
                </button>
              </div>

              <OidcIdpMetadataPopup
                  showModalOidcIdpMetadata={showModalOidcIdpMetadata}
                  handleHideModalOidcIdpMetadata={this.handleHideModalOidcIdpMetadata}
                  idpMetadata={idpMetadata}/>

              <div className="action-row">
                <button id="cancelSaveOidcApplicationButton"
                        className="btn btn-md cancel-save-button"
                        onClick={this.handleAddOidcCancel}>
                  {messageConstants.CANCEL}
                </button>
                &nbsp;
                <button id="saveOidcApplicationButton"
                        className="btn btn-md btn-primary save-button"
                        disabled={!applicationName || !userFriendlyName || !clientId || !entraIdTenantId
                          || oidcRedirectUris.filter(e => e.redirectUri.length > 0).length === 0}
                        onClick={this.handleSaveSP}>
                  {messageConstants.SBA_SAVE_BUTTON}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
}

const mapStateToProps = (state) => {
  return {
    errorMsg: state.sp.errorMsg,
    oidcProfile: state.sp.oidcProfile,
    oidcRedirectUris: state.sp.oidcRedirectUris,
    clientId: state.sp.clientId,
    applicationId: state.sp.applicationId,
    applicationName: state.sp.applicationName,
    userFriendlyName: state.sp.userFriendlyName,
    idpMetadata: state.idp,
    showModalOidcIdpMetadata: state.idp.showModalOidcIdpMetadata,
    entraIdTenantId: state.sp.entraIdTenantId
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateAppName: (e) => {
      dispatch(spActions.updateAppName(e))
    },
    updateUserFriendlyName: (e) => {
      dispatch(spActions.updateUserFriendlyName(e))
    },
    updateEntraIdTenantId: (e) => {
      dispatch(spActions.updateEntraIdTenantId(e))
    },
    addApp: (metadata) => {
      dispatch(spActions.addOidc(metadata));
    },
    updateApp: (metadata) => {
      dispatch(spActions.updateApp(metadata));
    },
    cancelAddApp: () => {
      dispatch(spActions.cancelAddApp());
    },
    getAppById: (applicationId) => {
      dispatch(spActions.getApp(applicationId))
    },
    updateOidcEntraIdEamRedirectUri: (value) => {
      dispatch(spActions.updateOidcEntraIdEamRedirectUri(value));
    },
    clearMessages: () => {
      dispatch(spActions.clearMessages())
    },
    setErrorMessage: (errorMessage) => {
      dispatch(spActions.setErrorMessage(errorMessage))
    },
    getIdpMetadata: () => {
      dispatch(idpActions.getIdpMetadata());
    },
    showOidcIdpMetadataPopup: () => {
      dispatch(idpActions.showOidcIdpMetadataPopup());
    },
    hideOidcIdpMetadataPopup: () => {
      dispatch(idpActions.hideOidcIdpMetadataPopup());
    },
    generateOidcClientCredentials: () => {
      dispatch(spActions.generateOidcClientCredentials());
    },
    redirectToWorkflowPolicyPage: () => {
      dispatch(spActions.redirectToWorkflowPolicyPage());
    }
  }
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OidcEntraIdEamApp);
